import * as types from "./actionTypes";
import { ErrorResponse } from "../../../interfaces/Response";
import { action, createAsyncAction } from "typesafe-actions";
import { createBookingAsyncRequest, createBookingAsyncResponse, FormExtension, getBookingAsyncRequest, getBookingAsyncResponse, searchBookingAsyncRequest, searchBookingAsyncResponse, selectBookingAsyncRequest, selectBookingAsyncResponse, updateBookingAsyncRequest, updateBookingAsyncResponse } from "./types";
import { Booking } from "../../../interfaces/Booking";

export const resetState = () => action(types.RESET_STATE, {});

export const setBooking = (value: Booking) => action(types.SET_BOOKING, { ...value });

export const setFormExtension = (value: FormExtension) => action(types.SET_FORM_EXTENSION, { ...value });

export const setError = (value: ErrorResponse) => action(types.SET_ERROR, { value });

export const getBookingAsync = createAsyncAction(
  types.GET_BOOKING_REQUEST,
  types.GET_BOOKING_SUCCESS,
  types.GET_BOOKING_FAILURE
)<getBookingAsyncRequest, getBookingAsyncResponse, ErrorResponse>();

export const searchBookingAsync = createAsyncAction(
  types.SEARCH_BOOKING_REQUEST,
  types.SEARCH_BOOKING_SUCCESS,
  types.SEARCH_BOOKING_FAILURE
)<searchBookingAsyncRequest, searchBookingAsyncResponse, ErrorResponse>();

export const updateBookingAsync = createAsyncAction(
  types.UPDATE_BOOKING_REQUEST,
  types.UPDATE_BOOKING_SUCCESS,
  types.UPDATE_BOOKING_FAILURE
)<updateBookingAsyncRequest, updateBookingAsyncResponse, ErrorResponse>();

export const createBookingAsync = createAsyncAction(
  types.CREATE_BOOKING_REQUEST,
  types.CREATE_BOOKING_SUCCESS,
  types.CREATE_BOOKING_FAILURE
)<createBookingAsyncRequest, createBookingAsyncResponse, ErrorResponse>();

export const selectBookingAsync = createAsyncAction(
  types.SELECT_BOOKING_REQUEST,
  types.SELECT_BOOKING_SUCCESS,
  types.SELECT_BOOKING_FAILURE
)<selectBookingAsyncRequest, selectBookingAsyncResponse, ErrorResponse>();